import Vue from 'vue'

export const userKey = '__knowledge_user'
export const baseApiUrl = 'https://ainurse.intelite.com.br/api/'
//export const baseApiUrl = 'http://localhost:3005/api/'
export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    convenioId: '0a79351c-3f37-4489-b504-1b72c643b15d'
}

export function showError(e) {
    if(e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ msg : e.response.data })
    } else if(typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg : e })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export default { baseApiUrl, showError, userKey }